import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-monitor-roof]',
    templateUrl: './monitor-roof.component.html',
    styleUrl: './monitor-roof.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MonitorRoofComponent {
  type = input<BuildingType>();
}
